const query = window.matchMedia('(max-width: 1024px)');

// ── Header height CSS var ────────────────────────────────────────────────────

const setHeaderHeight = () => {
    const header = document.querySelector('.Header');
    if (!header) return;
    document.documentElement.style.setProperty(
        '--header-height',
        `${header.offsetHeight}px`
    );
};

requestAnimationFrame(setHeaderHeight);
window.addEventListener('resize', setHeaderHeight);

// ── Mobile submenus ──────────────────────────────────────────────────────────

const initMobileSubMenus = () => {
    document.querySelectorAll('.Navigation__subMenu__go-back').forEach((btn) => {
        btn.addEventListener('click', () => {
            const parent = btn.closest('.Navigation__subMenu, .Navigation__megaPanel');
            if (parent) parent.classList.remove('open');
        });
    });

    document.querySelectorAll('.Navigation__chevron--top').forEach((chevron) => {
        chevron.addEventListener('click', () => {
            const li = chevron.closest('li');
            const panel = li.querySelector('.Navigation__subMenu, .Navigation__megaPanel');
            if (!panel) return;
            const isOpen = panel.classList.contains('open');
            panel.classList.toggle('open', !isOpen);
            chevron.setAttribute('aria-expanded', String(!isOpen));
        });
    });

    document.querySelectorAll('.Navigation__chevron:not(.Navigation__chevron--top)').forEach((chevron) => {
        chevron.addEventListener('click', () => {
            const li = chevron.closest('li');
            const nested = li.querySelector('ul');
            if (!nested) return;
            const isOpen = nested.classList.contains('open');
            nested.classList.toggle('open', !isOpen);
            chevron.setAttribute('aria-expanded', String(!isOpen));
        });
    });
};

if (query.matches) initMobileSubMenus();

query.addEventListener('change', (e) => {
    if (e.matches) initMobileSubMenus();
});